import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HubspotComponent } from './hubspot/hubspot.component';

@NgModule({
  exports: [HubspotComponent],
  imports: [CommonModule, HubspotComponent],
})
export class HubspotModule {}
